<div class="grid">
	<div class="col-12">
		<div class="card">
			<h5 *ngIf="router.url == '/app/users'">Clientes</h5>
			<h5 *ngIf="router.url == '/app/usersWorker'">Trabajadores</h5>
			<h5 *ngIf="router.url == '/app/usersBilling'">Usuarios facturación</h5>
			<p-table
				#dt1
				[value]="users"
				dataKey="id"
				[rows]="10"
				[loading]="loading"
				[rowHover]="true"
				[paginator]="true"
				[globalFilterFields]="[
					'name',
					'surname',
					'email',
					'phone_number',
					'status_string'
				]"
				responsiveLayout="scroll"
			>
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<button
							pButton
							label="Limpiar"
							class="p-button-rounded mb-2"
							(click)="clear(dt1)"
						></button>
						<span class="p-input-icon-left">
							<i class="pi pi-circle-fill"></i>
							<input
								pInputText
								type="text"
								#filter
								(input)="dt1.filterGlobal($event.target.value, 'contains')"
								placeholder="Buscar"
								class="w-full"
							/>
						</span>
						<div class="text-right">
							<button
								pButton
								pTooltip="Nuevo usuario"
								class="p-button-raised p-button-outlined m-1"
								icon="pi pi-plus"
								(click)="showDialog()"
							></button>
							<button
								pButton
								pRipple
								label="Actualizar"
								pTooltip="Actualizar listado de usuarios"
								type="button"
								icon="pi pi-refresh"
								class="p-button-raised p-button-outlined m-1"
								(click)="loadUsers(); clear(dt1)"
							></button>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="header">
					<!-- HEADERS -->
					<tr>
						<th class="text-center" pSortableColumn="name">
							<p-sortIcon field="name"></p-sortIcon>
							{{router.url == '/app/users' ? 'Razón social' : 'Nombre'}}
							
						</th>
						<th class="text-center" pSortableColumn="surname">
							<p-sortIcon field="surname"></p-sortIcon>
							{{router.url == '/app/users' ? 'Contacto' : 'Apellido'}}
						</th>
						<th class="text-center" pSortableColumn="number_document" *ngIf="router.url == '/app/users'">
							<p-sortIcon field="number_document"></p-sortIcon>
							NIF
						</th>
						<th class="text-center" pSortableColumn="email">
							<p-sortIcon field="email"></p-sortIcon>
							Email
						</th>
						<!-- <th class="text-center" pSortableColumn="role_id_string" *ngIf="router.url == '/app/usersWorker'">
							<p-sortIcon field="role_id_string"></p-sortIcon>
							Tipo
						</th> -->
						<th class="text-center" pSortableColumn="status_string">
							<p-sortIcon field="status_string"></p-sortIcon>
							Estado
						</th>
						<th></th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-user>
					<tr>
						<td class="text-center" style="min-width: 5rem">
							{{ user.name }}
						</td>
						<td class="text-center" style="min-width: 5rem">
							{{ user.surname }}
						</td>
						<td class="text-center" style="min-width: 5rem" *ngIf="router.url == '/app/users'">
							{{ user.number_document }}
						</td>
						<td class="text-left" style="min-width: 5rem">
							<div *ngIf="user.role_id == 4" class="circle-color" [style.background]="'#'+user.color"></div>
							{{ user.email }}
						</td>
						<!-- <td class="text-center" style="min-width: 5rem"  *ngIf="router.url == '/app/usersWorker'">
							{{user.role_id_string}}
						</td> -->
						<td class="text-center" style="min-width: 5rem">
							{{ user.status_string }}
						</td>
						<td class="text-center" style="min-width: 1rem">
							<button
								pButton
								pRipple
								type="button"
								pTooltip="Eliminar usuario"
								icon="pi pi-trash"
								class="p-button-danger p-button-raised p-button-outlined m-1"
								(click)="deleteUser(user)"
							></button>
							<button
								pButton
								pRipple
								type="button"
								pTooltip="Editar usuario"
								icon="pi pi-pencil"
								class="p-button-raised p-button-outlined m-1"
								(click)="showDialog(user)"
							></button>
							<button
								pButton
								pRipple
								type="button"
								[pTooltip]="user.status === 1 ? 'Desactivar' : 'Activar'"
								icon="pi {{
									user.status === 1 ? 'pi-thumbs-down' : 'pi-thumbs-up'
								}}"
								class="p-button-raised p-button-outlined m-1 p-button-{{
									user.status === 1 ? 'danger' : 'success'
								}}"
								(click)="updateStatus(user)"
							></button>
						</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Sin resultados</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Cargando usuarios...</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<!-- Modal recortador de imagen para creación-->
<p-dialog
	header="Recortador de imagen"
	[style]="{ width: '70vw' }"
	[(visible)]="croppedActive"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
>
	<div class="croppe">
		<image-cropper
			[imageChangedEvent]="imageChangedEvent"
			[maintainAspectRatio]="true"
			[aspectRatio]="3/3"
			[resizeToWidth]="512"
			[resizeToHeight]="512"
			format="png"
			output="base64"
			onlyScaleDown="true"
			imageQuality="95"
			(imageCropped)="imageCropped($event)"
			(imageLoaded)="imageLoaded($event)"
			(cropperReady)="cropperReady()"
			(loadImageFailed)="loadImageFailed()"
		></image-cropper>
	</div>
</p-dialog>


<!-- Modal para creación/edición de usuario -->
<p-dialog
	header="Datos de usuario"
	[(visible)]="dialogUser"
	[modal]="true"
	[style]="{ width: '80vw' }"
	[draggable]="false"
	[resizable]="false"
	(onHide)="resetForm()"
>
	<form [formGroup]="form">
		<div class="container-img">

			<div class="custom-file-upload" *ngIf="stringPhoto">
				<img [src]="stringPhoto" style="width: 220px" alt="Foto cargada" />
				<button
					class="ml-2"
					type="button"
					pButton
					icon="pi pi-trash"
					(click)="deletePhoto()"
				></button>
			</div>
			<div class="custom-file-upload">
				<input
					id="photoInputImage"
					type="file"
					(change)="handleUpload($event)"
					accept=".jpg,.png"
				/>
				<label class="btn-img">Selecciona imagen</label>
			</div>
		</div>
		
		<div class="grid p-fluid mt-3">

			<div class="field col-12 md:col-4 md:col-offset-4" *ngIf="form.get('role_id').value == 4">
				<label for="color" class="d-block">Color</label>
				<p-colorPicker formControlName="color"/>
			</div>

			
			<div class="field col-12 md:col-4 {{form.get('role_id').value != 4 ? 'md:col-offset-8' :''}}">
				<label for="services">Tipo de Usuario</label>
				<p-dropdown
					[style]="{ width: '100%' }"
					placeholder="Seleccione"
					optionLabel="name"
					optionValue="value"
					formControlName="role_id"
					appendTo="body"
					[options]="role_ids"
					[disabled]="isDropDownDisabled"
				>
			</p-dropdown>
			</div>

			<div class="field col-12 md:col-4">
				<label>{{router.url == '/app/users' ? 'Razón social' : 'Nombre'}} *</label>
				<input
					type="text"
					formControlName="name"
					pInputText
					class="w-full mb-3"
				/>
				<small
					class="p-error"
					*ngIf="
						form.get('name')!.errors &&
						form.get('name')!.touched &&
						form.get('name')!.hasError('required')
					"
					>Requerido</small
				>
				<small
					class="p-error"
					*ngIf="
						form.get('name')!.hasError('pattern') && form.get('name')!.touched
					"
					>Formato incorrecto</small
				>
			</div>
			<div class="field col-12 md:col-4">
				<label>{{router.url == '/app/users' ? 'Contacto' : 'Apellido'}} *</label>
				<input
					type="text"
					formControlName="surname"
					pInputText
					class="w-full mb-3"
				/>
				<small
					class="p-error"
					*ngIf="
						form.get('surname')!.errors &&
						form.get('surname')!.touched &&
						form.get('surname')!.hasError('required')
					"
					>Requerido</small
				>
				<small
					class="p-error"
					*ngIf="
						form.get('surname')!.hasError('pattern') &&
						form.get('surname')!.touched
					"
					>Formato incorrecto</small
				>
			</div>
			
			<div class="field col-12 md:col-4" *ngIf="form.get('role_id').value == 4">
				<label>NIF</label>
				<input
					type="text"
					formControlName="number_document"
					pInputText
					class="w-full mb-3"
				/>
			</div>
			<div class="field col-12 md:col-4">
				<label>Email *</label>
				<input
					type="email"
					formControlName="email"
					autocomplete="off"
					pInputText
					class="w-full mb-3"
				/>
				<small
					class="p-error"
					*ngIf="
						form.get('email')!.errors &&
						form.get('email')!.touched &&
						form.get('email')!.hasError('required')
					"
					>Requerido</small
				>
				<small
					class="p-error"
					*ngIf="
						form.get('email')!.hasError('email') && form.get('email')!.touched
					"
					>Ingrese un email con formato válido</small
				>
			</div>
			<div class="field col-12 md:col-4">
				<label *ngIf="mode === 'register'">Contraseña *</label>
				<label *ngIf="mode != 'register'">Contraseña</label>
				<p-password autocomplete="new-password" 
				formControlName="password" autocomplete="new-email" [toggleMask]="true"></p-password>
			</div>
			<div class="field col-12 md:col-4">
				<label *ngIf="mode === 'register'">Confirmar contraseña *</label>
				<label *ngIf="mode != 'register'">Confirmar contraseña</label>
				<p-password autocomplete="new-password"  
				formControlName="password_confirmation" [toggleMask]="true"></p-password>
				
				<small
					class="p-error"
					*ngIf="
						form.get('password_confirmation')!.errors &&
						form.get('password_confirmation')!.touched &&
						form.get('password_confirmation')!.hasError('required')
					"
					>Requerido
				</small>
				<small
					class="p-error"
					*ngIf="
						form.get('password_confirmation')!.errors &&
						form.get('password_confirmation')!.touched
					"
					>Contraseña y confirmación de contraseña no coinciden</small
				>
			</div>
			<div class="field col-12 md:col-4">
				<label>Teléfono</label>
				<input
					type="tel"
					formControlName="phone_number"
					pInputText
					maxlength="9"
					class="w-full mb-3"
				/>
				<small
					class="p-error"
					*ngIf="
						form.get('phone_number')!.hasError('pattern') &&
						form.get('phone_number')!.touched
					"
					>Introduzca valores numéricos</small
				>
			</div>
			<div class="flex justify-content-end col-12">
				<p-button
					styleClass="p-button-rounded"
					[label]="mode === 'register' ? 'Guardar' : 'Actualizar'"
					(click)="mode === 'register' ? registerUser() : updateUser()"
					[loading]="loading"
				>
				</p-button>
			</div>
		</div>
	</form>
</p-dialog>
